;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Required by Laravel Echo's Pusher broadcaster
if (typeof window !== 'undefined') {
  (window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher;
}

let echoInstance: Echo<'reverb'> | null = null;

export function createEcho(accessToken: string): Echo<'reverb'> | null {
  const appKey = process.env.NEXT_PUBLIC_REVERB_APP_KEY;
  console.log('[Echo] Creating Echo instance', {
    hasAppKey: !!appKey,
    wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
    wsPort: process.env.NEXT_PUBLIC_REVERB_PORT,
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
  });

  if (!appKey) {
    console.warn('[Echo] No REVERB_APP_KEY found, Echo will not be initialized');
    return null;
  }

  if (echoInstance) {
    console.log('[Echo] Disconnecting existing Echo instance');
    echoInstance.disconnect();
  }

  echoInstance = new Echo<'reverb'>({
    broadcaster: 'reverb',
    key: appKey,
    wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
    wsPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT) || 443,
    wssPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT) || 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: `${process.env.NEXT_PUBLIC_API_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
      },
    },
  });

  console.log('[Echo] Echo instance created successfully');
  return echoInstance;
}

export function getEcho(): Echo<'reverb'> | null {
  return echoInstance;
}

export function disconnectEcho(): void {
  if (echoInstance) {
    console.log('[Echo] Disconnecting Echo instance');
    echoInstance.disconnect();
    echoInstance = null;
  }
}
